<template>
  <div class="footer">
    <div class="footer_main">
      ©  gaohong  2019
    </div>
  </div>
</template>

<script>
export default {
  name:'Footer'
}
</script>

<style scoped>
.footer{
  text-align: center;
  background: #fff;
  width: 100%;
}
.footer_main{
  color: #e2e2e2;
  padding: 22px 0;
  font-size: 13px;
  line-height: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue